
import React from 'react';
import Gamification from '@/components/Gamification';
import { UserProgress } from '@/types/user';

interface ProgressSummarySectionProps {
  userProgress: UserProgress;
}

const ProgressSummarySection: React.FC<ProgressSummarySectionProps> = ({ userProgress }) => {
  // Calculate lessons completed
  const lessonsCompleted = userProgress?.completedDays?.length || 0;
  
  return (
    <div className="space-y-4">
      <Gamification 
        streak={userProgress?.streak || 0} 
        points={userProgress?.points || 0} 
        completedDay={userProgress?.completedDays?.includes(userProgress?.currentDay) || false}
        earnedPoints={10}
        currentDay={userProgress?.currentDay || 1}
        lessonsCompleted={lessonsCompleted}
      />
    </div>
  );
};

export default ProgressSummarySection;
